<template>
    <div>
        <div
            v-if="convention.compactInfo && convention.compactInfo.intro"
            v-html="convention.compactInfo.intro"
            class="compact-info-intro"
        />
        <div class="convention-sections">
            <div
                v-for="annotationsInSection in displayedAnnotations"
                :key="annotationsInSection.key"
                class="main-section"
            >
                <v-row no-gutters>
                    <v-col cols="auto">
                        <convention-sections-lines />
                    </v-col>
                    <v-col>
                        <convention-compact-info-annotation
                            :annotationsInSection="annotationsInSection"
                            :insurers="insurers"
                            :sections="sections"
                            :annotationOptions="annotationOptions"
                        />
                    </v-col>
                </v-row>
            </div>
        </div>
    </div>
</template>

<script>
import compactInfoManager from "./managers/compactInfoManager";
import ConventionCompactInfoAnnotation from "./ConventionCompactInfoAnnotation.vue";
import ConventionSectionsLines from "../obligations/sections/ConventionSectionsLines.vue";
import sectionsManager from "../../convention/managers/sectionsManager";
import { get } from "lodash";

export default {
    components: { ConventionCompactInfoAnnotation, ConventionSectionsLines },
    props: ["convention", "cspFilters", "insurers", "sections", "annotationOptions"],
    data() {
        return {};
    },
    methods: {
        initContent() {
            if (!this.convention.cspConfig.allIncluded) {
                const availableCodes = get(this.convention, "cspConfig.availableCodes", []);
                const ccBodySelector = `.ci-body, .cc-body > p,.cc-body > div, .cc-body > ul, .cc-body > table, .cc-body > span, .cc-body > .cc-article`;
                // Step 1 : add common legends
                sectionsManager.commonLegends(this.$el, availableCodes, ccBodySelector);

                // Step 2 : add title tags
                sectionsManager.cspTitleTags(this.$el, availableCodes);

                // Step 3 : add csp lines
                sectionsManager.cspLines(this.$el, availableCodes);
            }
        },
    },
    computed: {
        displayedAnnotations() {
            const { sections, annotationsByTitlePath } = this.convention;
            return compactInfoManager.buildDisplayedAnnotations(
                sections,
                annotationsByTitlePath,
                Object.keys(annotationsByTitlePath)
            );
        },
    },
    watch: {
        cspFilters() {
            sectionsManager.filterSections(this.$el, this.cspFilters);
        },
    },
    updated() {
        this.initContent();
    },
};
</script>

<style lang="sass" scoped>
.main-section
    padding-left: $grid-gutter * 1.5
    margin-bottom: $grid-gutter * 1.5

.filters
    margin-bottom: $grid-gutter

.compact-info-intro
    text-align: center
    margin: 16px 0 0 50px
</style>
